<template>
  <div>
    <Form :label-width="140">
      <!-- 基本信息 -->
      <Row :gutter="10" style="margin-bottom: 10px;">
        <Col span="24">
          <Card>
            <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">{{$t( 'resourceLifecycle.basicInformationVirtualMachine' )}}</p>
            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.cloudPlatform' )">
                  <span style="width: 200px;">{{accountTypeSearchKey}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.account' )">
                  <span style="width: 200px;">{{accountId}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.area' )">
                  <span style="width: 200px;">{{region}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.uses' )">
                  <span style="width: 200px;">{{use}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.periodofuse' )">
                  <span style="width: 200px;">{{periodOfUse}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.resourceType' )">
                  <span style="width: 200px;">{{resourceType}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.environment' )">
                  <span style="width: 200px;">{{environment}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.flow' )">
                  <span style="width: 200px;">{{approvalFlow}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.resourceGroup' )">
                  <span style="width: 200px;">{{resourceGroup}}</span>
                </FormItem>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
      <!-- 资源配置 -->
      <Row :gutter="10" style="margin-bottom: 10px;">
        <Col span="24">
          <Card>
            <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">{{$t( 'resourceLifecycle.resourceConfiguration' )}}</p>
            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.name' )">
                  <span style="width: 200px;">{{name}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.numberofinstances' )">
                  <span style="width: 200px;">{{numberOfInstances}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.username' )">
                  <span style="width: 200px;">{{userName}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.password' )">
                  <span style="width: 200px;">******</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.network' )">
                  <span style="width: 200px;">{{vpc}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.subnet' )">
                  <span style="width: 200px;">{{subnet}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.automaticdistributionofpublicIP' )">
                  <span style="width: 200px;">{{automaticallyAssignPublicIP}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="22">
                <FormItem :label="$t( 'resourceLifecycle.oSDiskType' )">
                  <span style="width: 200px;">{{diskType}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="8">
                <FormItem :label="$t( 'resourceLifecycle.models' )">
                  <span style="width: 200px;">{{columns.instanceType}}</span>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem :label="$t( 'resourceLifecycle.numberofCPUs' )">
                  <span style="width: 200px;">{{columns.instanceNumber}}</span>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem :label="$t( 'resourceLifecycle.memory' )">
                  <span style="width: 200px;">{{columns.ram}}</span>
                </FormItem>
              </Col>
            </Row>

            <!-- 镜像 -->
            <Row>
              <Col span="22">
                <FormItem :label="$t( 'resourceLifecycle.operatingsystem' )">
                  <Row :gutter="10">
                    <Col span="11">
                      <FormItem>
                        <span style="width: 200px;">{{os}}</span>
                      </FormItem>
                    </Col>
                    <Col span="11">
                      <FormItem>
                        <span style="width: 200px;">{{mirror}}</span>
                      </FormItem>
                    </Col>
                  </Row>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="22">
                <!-- 标签 -->
                <FormItem>
                  <Row>
                    <Col v-for="(item,index) in tags" v-bind:key="index" span="8">
                      <Tag color="default">{{item.key}} : {{item.value}}</Tag>
                    </Col>
                  </Row>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="22">
                <FormItem :label="$t( 'resourceLifecycle.exhibits' )" prop="enclosure">
                  <Table :no-data-text="$t('common.noData')" border :columns="columnsFile" :data="fileData" :border="false">
                    <template slot-scope="{row,index}" slot="download">
                      <!-- 下载 -->
                      <Button type="success" :loading="modal_loadings" size="small" @click="downloadFile(row)">{{$t('resourceLifecycle.download')}}
                      </Button>
                    </template>
                  </Table>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="22">
                <FormItem :label="$t( 'resourceLifecycle.remarkation' )">
                  <span style="width: 200px;">{{describe}}</span>
                </FormItem>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>


      <!-- 预估费用 -->
      <Row :gutter="10" style="margin-bottom: 10px;">
        <Col span="24">
          <Card>
            <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">{{$t( 'resourceLifecycle.estimatedcosts' )}}</p>
            <Row>
              <Col span="12">
                <FormItem :label="$t( 'resourceLifecycle.estimatedcost' )">
                  <i style="font-size: 20px;">￥ {{cost}}</i>
                </FormItem>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Form>
  </div>
</template>

<script>
  export default {
    name: 'AzureVirtualMachineDetail',
    props: ['azureResourceApplicationBasicInfoForm'],
    components: {},
    data() {
      return {
        cost: 0,
        modal_loadings: false,//下载
        resourceGroup: '',
        userName: '',
        password: '',
        accountTypeSearchKey: '',
        accountId: '',
        region: '',
        use: '',
        periodOfUse: '',
        resourceType: '',
        environment: '',
        approvalFlow: '',
        name: '',
        numberOfInstances: '',
        keyName: '',
        diskSize: '',
        os: '',
        mirror: '',
        subnet: '',
        vpc: '',
        automaticallyAssignPublicIP: '',
        describe: '',
        tags: [],
        diskType: '',
        columns: [
          {
            title: this.$t( 'resourceLifecycle.series' ),
            key: 'name'
          },
          {
            title: this.$t( 'resourceLifecycle.models' ),
            key: 'instanceId'
          },
          {
            title: this.$t( 'resourceLifecycle.numberofCPUs' ),
            key: 'agentVersion'
          },
          {
            title: this.$t( 'resourceLifecycle.rAM' ),
            key: 'availabilityZone'
          }
        ],
        cloudPlatformSpecificationsDate: [],
        columnsFile: [
          {
            title: this.$t( 'resourceLifecycle.filenames' ),
            key: 'fileName'
          },
          {
            title: this.$t( 'resourceLifecycle.fileType' ),
            key: 'fileType'
          },
          {
            title: this.$t('common.operation'),
            slot: 'download',
            "width": 100
          }],
        fileData: []
      }
    },
    mounted: function () {
      this.dealWithLine();
    },
    methods: {
      // 处理
      /****************************************************/
      dealWithLine: function () {
        // 审批
        this.$api.lifecycleResourceApplication.queryLifecycleResourceById({
          "id": this.azureResourceApplicationBasicInfoForm.id
        })
          .then(res => {
            // Common Params
            this.accountTypeSearchKey = res.data.platformString;
            this.accountId = res.data.accountName;
            this.region = res.data.region;
            this.use = res.data.usageNote;
            this.periodOfUse = res.data.duration + this.$t( 'resourceLifecycle.months' );
            this.resourceType = res.data.lifecycleResourceTypeDesc;
            this.environment = res.data.environmentDesc;
            this.approvalFlow = res.data.approvalFlow;
            this.describe = res.data.remark;
            this.cost = res.data.cost;
            if (res.data.attachmentList != null && res.data.attachmentList != undefined && res.data.attachmentList.length > 0) {
              this.fileData = res.data.attachmentList;
            }

            this.resourceGroup = res.data.lifecycleResourceInstanceDTO.resourceGroup;
            this.name = res.data.lifecycleResourceInstanceDTO.name;
            this.numberOfInstances = res.data.lifecycleResourceInstanceDTO.instanceNumber;
            this.userName = res.data.lifecycleResourceInstanceDTO.userName;
            this.password = res.data.lifecycleResourceInstanceDTO.password;
            this.vpc = res.data.lifecycleResourceInstanceDTO.vpc;
            this.subnet = res.data.lifecycleResourceInstanceDTO.virtualNetworkSubnet;
            this.automaticallyAssignPublicIP = res.data.lifecycleResourceInstanceDTO.isAllocationPublicIp == true ? this.$t( 'resourceLifecycle.yes' ) : this.$t( 'resourceLifecycle.no' );
            var volumeList = res.data.lifecycleResourceVolumes;
            if (volumeList != null && volumeList != undefined && volumeList.length > 0) {
              this.diskType = volumeList[0].type;

            }
            this.os = res.data.lifecycleResourceInstanceDTO.lifecycleResourceInstanceOsDTO.osOffer;
            this.mirror = res.data.lifecycleResourceInstanceDTO.lifecycleResourceInstanceOsDTO.osVersion;
            this.tags = res.data.resourceTags;

            this.columns.instanceType = res.data.lifecycleResourceInstanceDTO.instanceType;
            this.columns.instanceNumber = res.data.lifecycleResourceInstanceDTO.instanceNumber;
            this.columns.ram = res.data.lifecycleResourceInstanceDTO.ram;
          })
      },
      // 下载附件
      /************************************************************/
      downloadFile: function (row) {
        // 下载附件
        this.modal_loadings = true;
        this.$api.file.downloadFile("id", row.id)
          .then(res => {
            let aTag = document.createElement('a');
            let blob = new Blob([res.data], {type: 'text/plain;charset=UTF-8'})
            aTag.download = row.fileName;
            aTag.href = URL.createObjectURL(blob);
            aTag.click();
            URL.revokeObjectURL(blob);
            setTimeout(() => {
              this.modal_loadings = false;
              this.$Message.success(this.$t( 'resourceLifecycle.response.downloadSuccess'));
            }, 1000);
          })
      }
    }
  }
</script>

<style scoped>
  .ivu-form-item {
    margin-bottom: 0px !important;
    vertical-align: top;
    zoom: 1;
  }
</style>




// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_application/azure/virtual_machine/AzureVirtualMachineDetail.vue